import React, { useCallback, useState } from 'react';

import { setLocalStorage } from '@zola-helpers/client/dist/es/util/storage';
import TourTooltip from '@zola/zola-ui/src/components/TourTooltip/TourTooltip';

import Joyride, { ACTIONS, CallBackProps, EVENTS, Step } from 'react-joyride';

import styles from './shadowboxTour.module.less';

export interface ShadowboxTourProps {
  steps: Step[];
  onTourComplete?: () => void;
  localStorageKey?: string;
}

const ShadowboxTour = (props: ShadowboxTourProps) => {
  const { steps, localStorageKey, onTourComplete } = props;

  const [completed, setCompleted] = useState(false);

  const handleJoyrideCallback = useCallback(
    (data: CallBackProps) => {
      const { action, type: dataType } = data;

      switch (dataType) {
        case EVENTS.TOUR_END:
          if (action === ACTIONS.CLOSE || action === ACTIONS.SKIP) {
            setCompleted(true);
          }
          if (onTourComplete) onTourComplete();
          if (localStorageKey) setLocalStorage(localStorageKey, JSON.stringify(true));
          break;

        default:
      }
    },
    [localStorageKey, onTourComplete]
  );

  if (completed) return null;

  return (
    <Joyride
      steps={steps}
      callback={handleJoyrideCallback}
      showProgress
      continuous
      showSkipButton
      scrollToFirstStep
      scrollOffset={250}
      spotlightPadding={4}
      styles={{
        options: {
          zIndex: 1000,
        },
      }}
      tooltipComponent={({ children, tooltipProps, ...rest }) =>
        React.createElement(
          TourTooltip,
          {
            ...rest,
            tooltipProps: {
              ...tooltipProps,
              // @ts-expect-error TourTooltip doesn't explicitly have the className as a prop and just spreads the props onto the element
              className: styles.tooltipWrapper,
            },
          },
          children
        )
      }
      floaterProps={{
        disableAnimation: true,
        offset: 8,
        styles: {
          arrow: {
            length: 8,
            spread: 16,
          },
        },
      }}
    />
  );
};

export default ShadowboxTour;
